/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
export const ANALYTICS_EVENTS = {
  VIDEO_PLAYED: "video_played",
  VIDEO_DROPPED: "video_dropped",
} as const;

export const ANALYTICS_GA_CATEGORIES = {
  VIDEO_PLAYER: "video_player",
} as const;
